import smoothScroll from '../smoothScroll';

// Helper method to scroll a target element with optionally some duration
const animateScrollToTop = ({
  position,
  // @NOTE using both body and html for cross browser differences
  // firefox overflows at html-level and not body-level as webkit based browsers do
  // @see: https://stackoverflow.com/questions/21556752/jquery-scrolltop-not-working-on-body-element-in-firefox
  targetElement = 'body, html',
  duration = 0,
}) => {
  const elements = targetElement.split(', ');
  elements.forEach((element) => {
    smoothScroll({
      element: document.querySelector(element),
      duration,
      y: position,
    });
  });
};

export default animateScrollToTop;
